export const FIREBASE_CONFIG ={
    apiKey: "AIzaSyDK5z1n5uVQvTnVmAHWLTvGCnpacALPPFM",
    authDomain: "wall-fd811.firebaseapp.com",
    databaseURL: "https://wall-fd811.firebaseio.com",
    projectId: "wall-fd811",
    storageBucket: "wall-fd811.appspot.com",
    messagingSenderId: "973249818990"
};


// WEBPACK FOOTER //
// ./src/config/firebase.credentials.ts